import { useRequestProfileContext } from '../RequestProfile.hooks'

import { RequestProfileTabEmailsContent } from './RequestProfileTabEmailsContent'

function RequestProfileTabEmails({ onLoadCounters }) {
  const { requestId } = useRequestProfileContext()

  return (
    <RequestProfileTabEmailsContent
      requestId={requestId}
      onLoadCounters={onLoadCounters}
    />
  )
}

export default RequestProfileTabEmails
